import { render, staticRenderFns } from "./CannabisAppointment.vue?vue&type=template&id=38d0c54e&scoped=true"
import script from "./CannabisAppointment.vue?vue&type=script&lang=js"
export * from "./CannabisAppointment.vue?vue&type=script&lang=js"
import style0 from "./CannabisAppointment.vue?vue&type=style&index=0&id=38d0c54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0c54e",
  null
  
)

export default component.exports